import { ADMIN_PERMISSION_NAME } from '@/constant/api';

import { AutorizationResponseType } from '@/types/authorization';

export const isAdmin = (user: AutorizationResponseType) =>
	user?.permissions?.some(
		(permission) => permission === ADMIN_PERMISSION_NAME,
	);
